<template>

  <ion-page id="stripe-cancel-page">
    <ion-content>

      <TopLine :style="styleTopline" :title="stripeAccountlTitleString" :microphoneIsMuted="microphoneIsMuted" @topline-click="toplineClick"/>

      <div :style="styleMiddle" :class="{ 'text-light' : !isDark,'text-dark' : isDark}">
        <ion-item>
          <ion-label>
            <h1>{{ translatePhrase("You are back in Verbal Chess") }}</h1>
          </ion-label>
        </ion-item>
      </div>
      <ToolBar :style="styleToolbar" :elements="toolbarElements" :trigger="toolbarTrigger" @toolbar-click="toolbarClick" />
    </ion-content>
  </ion-page>

</template>

<script setup>

  import { IonPage, IonContent,IonList,IonItem,IonLabel  } from '@ionic/vue';

  import { computed } from "@vue/reactivity"
  import { ref , watch } from 'vue'
  import { useConnectionStore } from '@/stores/connectionStore';
  import { useWindowSizeStore } from '@/stores/windowSizeStore';

  import { parseWordsSaid , parseGeneralWordsSaid } from '@/composables/wordlistSupport.js'
  import ToolBar from '@/components/ToolBar.vue'
  import { doStartupCheck } from '@/composables/startupCheck.js'
  import TopLine from '@/components/TopLine.vue'
  import { useRouter } from 'vue-router';
  import { translateEnglishWords, translatePhrase } from '@/composables/translation';

  import { buildStyleToolbar, buildStyleTopline,buildStyleMiddle,availableWidthHeight, 
    calculateChessBoardRect, isScreenPortraitOrientation } from '@/composables/screenSize'

  const emit = defineEmits(['where-next','word-list','mic-is-muted'])

  const props = defineProps({
      wordsSaid : {
        type : String,
        default : ""
      },
      wordsSaidTrigger : {
        type : Number,
        default : 0
      }
    })

  const wordsSaid = computed({get() {return props.wordsSaid}})
  const wordsSaidTrigger = computed({get() {return props.wordsSaidTrigger}})

  const connectionStore = useConnectionStore()
  const windowSizeStore = useWindowSizeStore()

  const isDark = ref(connectionStore.getDarkmode != "light")

  const wordlist = ref("command done mute listen ignore")
  const wordlistTrigger = ref(0)

  const stripeAccountlTitleString = ref(translatePhrase("Stripe Portal Return"))
  const TOOLBAR_DONE = 0

  const toolbarElements = ref([
  ])
  const toolbarTrigger = ref(0)

  const microphoneIsMuted = ref(connectionStore.getMicrophoneIsMuted)
  emit("mic-is-muted",microphoneIsMuted.value)

  const styleToolbar = ref(buildStyleToolbar(availableWidthHeight()))
  const styleTopline = ref(buildStyleTopline(availableWidthHeight()))
  const styleMiddle = ref(buildStyleMiddle(availableWidthHeight()))

  doStartupCheck(true)

  watch(wordsSaidTrigger, (newVal,oldVal) => {
     //console.log('*********** words said ',props.wordsSaid)
     processWords(props.wordsSaid)
   })

  watch(() => windowSizeStore.getWindowSize, () => {
    styleToolbar.value = buildStyleToolbar(availableWidthHeight())
    styleTopline.value = buildStyleTopline(availableWidthHeight())
    styleMiddle.value = buildStyleMiddle(availableWidthHeight())
  })

  function toplineClick(whatClicked) {
    //console.log("topline",whatClicked)
    switch (whatClicked) {
      case "done" :
        processWords("command done")
        break;
      case "microphone" :
        microphoneIsMuted.value = !microphoneIsMuted.value 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(microphoneIsMuted.value)
        break

    }
  }

  function toolbarClick(arrayIndex) {
  }

  function parseCommands(words,currentWordIndex) {
    
    //console.log("in parse commands",words,currentWordIndex)
    var currentWord = (words.length > currentWordIndex) ? words[currentWordIndex] : "xyz"
    var nextWord = (words.length > currentWordIndex+1) ? words[currentWordIndex+1] : "xyz"
    var nextNextWord = (words.length > currentWordIndex+2) ? words[currentWordIndex+2] : "xyz"

    for (var i = 0; i < words.length; i++) {
        if (currentWord == "ignore") {
            return ["ignore",""];
        }
        if (currentWord == "done") {
            return ["done",""]
        }
       
        currentWord = nextWord;
        nextWord = nextNextWord;
        nextNextWord = (i < words.length - 3) ? words[i + 3] : "xyz";
    }
    return (["ignore",""]);
  }

  function processWords(text) {
    //console.log("text in Connect ",text)
    var returnArray = parseWordsSaid(text,parseCommands)
    //console.log("command found",returnArray)

    switch (returnArray[0]) {
      case "done" :
        emit("where-next","/")
        break
    }
  }
  
</script>

<style scoped>

</style>
